import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
import '@/assets/css/theme/index.css'
import request from "@/utils/request";
import moment from "moment";
//需要汉化
moment.locale('zh-cn');
Vue.prototype.$moment = moment;//赋值使用


Vue.config.productionTip = false

Vue.prototype.$request = request
// 根据角色授权判断是否具备某按钮权限（从 xm-permissions 读取，由 Manager 加载）
Vue.prototype.$hasButtonPerm = function (code) {
  try {
    const p = JSON.parse(localStorage.getItem('xm-permissions') || '{}')
    return (p.buttonCodes || []).includes(code)
  } catch (e) {
    return false
  }
}
// 根据角色授权判断是否具备某菜单权限
Vue.prototype.$hasMenuPerm = function (code) {
  try {
    const p = JSON.parse(localStorage.getItem('xm-permissions') || '{}')
    return (p.menuCodes || []).includes(code)
  } catch (e) {
    return false
  }
}
// 根据环境设置baseUrl，用于文件上传等直接拼接URL的场景
// 生产环境使用相对路径 /api，会自动使用当前域名
// 开发环境使用环境变量或默认值
Vue.prototype.$baseUrl = process.env.NODE_ENV === 'production'
    ? '/api'
    : (process.env.VUE_APP_BASEURL || 'http://127.0.0.1:9090')

Vue.use(ElementUI, {size: "small"})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
